<template>
  <i-modal
    class="modal-property-quick-edit"
    v-model="modal"
    title="物件確認～簡易編集～"
    width="1360"
    :styles="{ top: '40px' }"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-property-quick-edit__container">
      <i-form label-position="left" :label-width="120">
        <i-row class="flex-wrap">
          <!-- 価格 -->
          <i-col span="12">
            <i-form-item label="価格">
              <div class="form__input">
                <InputNumber :value.sync="formItem.b_price_low" :width="160" />
                <span class="form__label">万円</span>
              </div>
            </i-form-item>
          </i-col>
          <!-- 管理費 -->
          <i-col span="12">
            <i-form-item label="管理費">
              <div class="form__input">
                <InputNumber :value.sync="formItem.management_fee" :width="160" />
                <span class="form__label">円</span>
              </div>
            </i-form-item>
          </i-col>
          <!-- 修繕積立金 -->
          <i-col span="12">
            <i-form-item label="修繕積立金">
              <div class="form__input">
                <InputNumber :value.sync="formItem.repair_reserve_cost" :width="160" />
                <span class="form__label">円</span>
              </div>
            </i-form-item>
          </i-col>
          <!-- 取引態様 -->
          <i-col span="12">
            <i-form-item label="取引態様">
              <div class="form__input">
                <i-select v-model="formItem.mi_transaction_form_cd" clearable style="width: 160px;">
                  <template v-for="(item, idx) in master.transaction_form">
                    <i-option :key="`transactionForm${idx}`" :value="Number(item.cd)">{{ item.label }}</i-option>
                  </template>
                </i-select>
              </div>
            </i-form-item>
          </i-col>
          <!-- 確認日 -->
          <i-col span="12">
            <i-form-item label="確認日">
              <div class="form__input">
                <i-select v-model="formItem.confirm_y" clearable style="width: 130px;">
                  <template v-for="(item, idx) in masterYear">
                    <template v-if="item.value >= 1970 && item.value <= new Date().getFullYear()">
                      <i-option :key="`confirmY${idx}`" :value="Number(item.value)">{{ item.label }}</i-option>
                    </template>
                  </template>
                </i-select>
                <span class="form__label">年</span>
                <i-select v-model="formItem.confirm_m" clearable style="width: 60px;">
                  <template v-for="month in 12">
                    <i-option :key="`confirmM${month}`" :value="month">{{ month }}</i-option>
                  </template>
                </i-select>
                <span class="form__label">月</span>
                <i-select v-model="formItem.confirm_d" clearable style="width: 60px;">
                  <template v-for="day in 31">
                    <i-option :key="`confirmD${day}`" :value="day">{{ day }}</i-option>
                  </template>
                </i-select>
                <span class="form__label">日</span>
                <BtnDatePicker :value.sync="dateCalendarConfirmDate" />
                <i-button type="success" size="small" @click="onClickToday" style="margin-left: 8px;">
                  本日を挿入
                </i-button>
              </div>
            </i-form-item>
          </i-col>
          <!-- 販売状態 -->
          <i-col span="12">
            <i-form-item label="販売状態">
              <div class="form__input">
                <i-select v-model="formItem.mi_sale_state_cd" clearable style="width: 160px;">
                  <template v-for="(item, idx) in master.sale_state">
                    <i-option :key="`saleState${idx}`" :value="Number(item.cd)">{{ item.label }}</i-option>
                  </template>
                </i-select>
              </div>
            </i-form-item>
          </i-col>
          <!-- 現況 -->
          <i-col span="12">
            <i-form-item label="現況">
              <div class="form__input">
                <i-select v-model="formItem.m_vacant_type_id" clearable style="width: 160px;">
                  <template v-for="(item, idx) in selVacantType">
                    <i-option :key="`vacantType${idx}`" :value="Number(item.cd)">{{ item.label }}</i-option>
                  </template>
                </i-select>
              </div>
            </i-form-item>
          </i-col>
          <!-- フリータグ1〜5 -->
          <i-col v-for="n in 5" :key="`freeTagRow${n}`" span="12">
            <i-form-item :label="`フリータグ${n}`">
              <div class="form__input">
                <i-input v-model="formItem[`free_tag_${n}`]" style="width: 320px;" />
              </div>
            </i-form-item>
          </i-col>
          <!-- 投資用: 利回り / 満室時年収 -->
          <template v-if="type === 'investment'">
            <i-col span="12">
              <i-form-item label="利回り">
                <div class="form__input">
                  <InputNumber :value.sync="formItem.yield" :width="160" />
                  <span class="form__label">％</span>
                </div>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="満室時年収">
                <div class="form__input">
                  <InputNumber :value.sync="formItem.income_price" :width="160" />
                  <span class="form__label">万円</span>
                </div>
              </i-form-item>
            </i-col>
          </template>
          <!-- クローズ情報 -->
          <i-col span="12">
            <i-form-item label="クローズ情報">
              <div class="form__input">
                <i-input
                  v-model="formItem.closed_info"
                  type="textarea"
                  :rows="3"
                  style="width: 320px;"
                />
              </div>
            </i-form-item>
          </i-col>
        </i-row>
      </i-form>
    </div>

    <div class="form__footer" slot="footer">
      <i-button @click="modal = false">キャンセル</i-button>
      <i-button type="primary" @click="onClickSave">保存</i-button>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Row, Col, Form, FormItem, Select, Option, Input, Button } from 'view-design'
import InputNumber from '@/components/parts/InputNumber'
import BtnDatePicker from '@/components/parts/BtnDatePicker'
import BukkenRepository from '@/repositories/bukkenRepository'
import Common from '@/mixins/common'

export default {
  mixins: [Common],
  components: {
    'i-modal': Modal,
    'i-row': Row,
    'i-col': Col,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option,
    'i-input': Input,
    'i-button': Button,
    InputNumber,
    BtnDatePicker,
  },

  data() {
    return {
      dateCalendarConfirmDate: '',
    }
  },

  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalPropertyQuickEdit/getModal']
      },
      set(val) {
        this.$store.commit('ModalPropertyQuickEdit/setModal', val)
      },
    },
    id() {
      return this.$store.getters['ModalPropertyQuickEdit/getId']
    },
    mBTypeId() {
      return this.$store.getters['ModalPropertyQuickEdit/getMBTypeId']
    },
    type() {
      return this.$store.getters['ModalPropertyQuickEdit/getType']
    },
    formItem: {
      get() {
        return this.$store.getters['ModalPropertyQuickEdit/getFormItem']
      },
      set(val) {
        this.$store.commit('ModalPropertyQuickEdit/setFormItem', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
    masterYear() {
      return this.$store.getters['Master/getYear']
    },
    property: {
      get() {
        return this.$store.getters['Property/getProperty']
      },
      set(val) {
        this.$store.commit('Property/setProperty', val)
      },
    },
    // 現況 プルダウン（物件種別に応じてフィルタリング）
    selVacantType() {
      if (!this.mBTypeId || !this.master.vacant_type) return []
      const idx = String(this.mBTypeId).slice(0, 2)
      return this.master.vacant_type[idx] || []
    },
  },

  watch: {
    dateCalendarConfirmDate(val) {
      if (val) {
        const ymd = new Date(val).toLocaleDateString().split('/')
        this.formItem.confirm_y = Number(ymd[0])
        this.formItem.confirm_m = Number(ymd[1])
        this.formItem.confirm_d = Number(ymd[2])
      }
    },
  },

  methods: {
    // モーダル開閉時処理
    onVisibleChange(isOpen) {
      if (!isOpen) {
        setTimeout(this.resetParams, 300)
      }
    },
    // 本日挿入ボタン クリック処理
    onClickToday() {
      const d = new Date()
      this.formItem.confirm_y = d.getFullYear()
      this.formItem.confirm_m = d.getMonth() + 1
      this.formItem.confirm_d = d.getDate()
    },
    // 保存ボタン クリック処理
    async onClickSave() {
      const params = {}
      _.forEach(this.formItem, (val, key) => {
        params[key] = _.isUndefined(val) ? null : val
      })
      // 居住用の場合、投資用専用フィールドを送信しない（既存データの上書き防止）
      if (this.type === 'residence') {
        delete params.yield
        delete params.income_price
      }
      await this.patchQuickEdit(params)
    },
    // 簡易編集 更新処理
    async patchQuickEdit(params) {
      this.$store.dispatch('Loading/setLoading', true)
      await BukkenRepository.patchQuickEdit(this.id, params)
        .then(res => {
          if (res && res.result) {
            // 物件一覧の表示を即時更新
            const propertyId = this.id
            const property = _.find(this.property, item => item.id === propertyId)
            if (property) {
              property.b_price_low              = params.b_price_low
              property.management_fee           = params.management_fee
              property.repair_reserve_cost      = params.repair_reserve_cost
              property.mi_transaction_form_cd   = params.mi_transaction_form_cd
              property.confirm_y                = params.confirm_y
              property.confirm_m                = params.confirm_m
              property.confirm_d                = params.confirm_d
              property.mi_sale_state_cd         = params.mi_sale_state_cd
              property.m_vacant_type_id         = params.m_vacant_type_id
              property.closed_info              = params.closed_info
              for (let n = 1; n <= 5; n++) {
                property[`free_tag_${n}`] = params[`free_tag_${n}`]
              }
              // 投資用フィールド更新
              if (this.type === 'investment') {
                property.yield        = params.yield
                property.income_price = params.income_price
                property._income_price_per_month =
                  params.income_price != null ? Math.round((params.income_price / 12) * 100) / 100 : null
              }
              // 表示用フィールドを更新
              const saleStateItem = _.find(this.master.sale_state, { cd: params.mi_sale_state_cd })
              property._sale_state = saleStateItem ? saleStateItem.label : ''

              const vacantTypeItem = _.find(this.selVacantType, { cd: params.m_vacant_type_id })
              property._vacant_type = vacantTypeItem ? vacantTypeItem.label : ''

              const transactionFormItem = _.find(this.master.transaction_form, { cd: params.mi_transaction_form_cd })
              property._transaction_form = transactionFormItem ? transactionFormItem.label : ''

              property._confirm_date = this.formatConfirmDate(params.confirm_y, params.confirm_m, params.confirm_d)
              property._closed_info  = params.closed_info ? '○' : ''
            }
          } else {
            alert('物件情報の更新に失敗しました。')
          }
        })
        .catch(() => {
          alert('物件情報の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
          this.modal = false
        })
    },
    // 確認日 表示フォーマット
    formatConfirmDate(y, m, d) {
      if (!y || !m || !d) return '-'
      return `${y}/${('00' + m).slice(-2)}/${('00' + d).slice(-2)}`
    },
    // パラメータリセット
    resetParams() {
      const bodyElement = document.getElementById('top')
      if (bodyElement) bodyElement.style.overflow = 'visible'
      this.dateCalendarConfirmDate = ''
      this.$store.dispatch('ModalPropertyQuickEdit/reset')
    },
  },
}
</script>

<style lang="scss">
.modal-property-quick-edit {
  &__container {
    max-height: 480px;
    overflow-y: auto;
    .ivu-row {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .ivu-form-item {
    min-height: 54px;
    margin-bottom: 2px;
    .ivu-form-item-label {
      font-weight: bold;
    }
  }
  .ivu-input-wrapper,
  .ivu-select {
    margin: 0 2px;
  }
  .form {
    &__label {
      margin: 0 4px;
    }
    &__input {
      display: flex;
      align-items: center;
    }
    &__footer {
      text-align: center;
    }
  }
  textarea.ivu-input {
    font-size: 12px;
  }
}
</style>
